import PropTypes from 'prop-types'
import React from 'react'
import Select, { components } from 'react-select'
import AsyncSelect from 'react-select/async'
import CreatableSelect from 'react-select/creatable'

import ChevronDown from '../../icons/ChevronDown'
import { getBrumbrumColor } from '../utils'

const { white, successMain, errorMain, grey600, grey800, blackA80, blackA120 } =
  getBrumbrumColor()
const DropdownIndicator = props => (
  <components.DropdownIndicator className={`chevron`} {...props}>
    <ChevronDown />
  </components.DropdownIndicator>
)

const Input = ({ selectProps, ...props }) => (
  <components.Input data-cy={selectProps.dataCy} {...props} />
)

const BuySelectInput2 = ({
  label,
  values,
  update,
  liClassName,
  value,
  labelStyle,
  defaultValue,
  disabled,
  optionHeight,
  async,
  placeholder,
  loadOptions,
  clearable,
  noOptionsMessage,
  name,
  creatable,
  onCreateOption,
  formatCreateLabel,
  dataCy,
}) => {
  const Ss = async ? AsyncSelect : creatable ? CreatableSelect : Select
  const isError = !!liClassName?.includes('is-required')
  const _defaultValue = values.filter(
    __value => __value.value === defaultValue || __value.value === value
  )

  return (
    <li className={liClassName || 'wide'}>
      <Ss
        className="brumbrum-select"
        components={{
          DropdownIndicator,
          Input,
        }}
        dataCy={dataCy}
        defaultValue={_defaultValue}
        formatCreateLabel={formatCreateLabel}
        isClearable={clearable}
        isDisabled={disabled}
        isSearchable
        loadOptions={loadOptions}
        loadingMessage={({ inputValue }) =>
          `Ricerca in corso per ${inputValue}`
        }
        matchPos="start"
        matchProp="label"
        name={name}
        noOptionsMessage={({ inputValue }) =>
          inputValue
            ? noOptionsMessage
              ? noOptionsMessage(inputValue)
              : `Nessun risultato per ${inputValue}`
            : 'Digita un carattere'
        }
        noResultsText={'nessun risultato'}
        onChange={update}
        onCreateOption={onCreateOption}
        optionHeight={optionHeight}
        options={values}
        placeholder={placeholder}
        searchingText={'Ricerca in corso'}
        // https://github.com/bvaughn/react-virtualized-select#react-virtualized-select-props
        styles={getReactSelectStyles(isError)}
        theme={getReactSelectTheme}
        value={_defaultValue}
      />
      {label && (
        <label className="label" style={labelStyle}>
          {label}
        </label>
      )}
    </li>
  )
}

const getReactSelectTheme = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: grey800,
    primary25: blackA80,
    primary50: grey800,
    primary75: grey600,
    neutral0: white,
    neutral5: blackA120,
    neutral10: grey600,
    neutral20: grey600,
    neutral30: grey800,
    neutral60: grey600,
    neutral70: grey600,
    neutral80: grey800,
    neutral90: grey800,
    danger: errorMain,
  },
})

const getReactSelectStyles = isError => {
  const getStatusColor = ({ hasValue, isFocused }, _isError) => {
    if (hasValue) {
      return successMain
    }
    if (isFocused) {
      return grey800
    }
    if (_isError) {
      return errorMain
    }
    return grey600
  }

  const getOptionBackgroundColor = ({ isFocused, isActive, isSelected }) => {
    if (isSelected) {
      return grey800
    }
    if (isFocused || isActive) {
      return blackA80
    }
    return white
  }

  return {
    control: (provided, state) => ({
      ...provided,
      border: `1px solid ${getStatusColor(state, isError)}`,
      borderRadius: '16px',
      height: '46px',
      width: '100%',
    }),
    dropdownIndicator: (provided, { selectProps: { menuIsOpen } }) => ({
      ...provided,
      transform: menuIsOpen && 'rotate(180deg)',
    }),
    indicatorSeparator: provided => ({
      ...provided,
      backgroundColor: grey600,
      height: '26px',
    }),
    input: provided => ({
      ...provided,
      padding: '0px',
      margin: '0px',
    }),
    menu: provided => ({
      ...provided,
      border: `1px solid ${grey800}`,
      borderRadius: '4px',
      boxShadow: `0px 4px 10px rgba(0, 0, 0, 0.2)`,
      zIndex: 999,
      fontSize: '14px',
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? white : grey800,
      backgroundColor: getOptionBackgroundColor(state),
    }),
    valueContainer: provided => ({
      ...provided,
      border: 'none',
      alignContent: 'center',
      margin: '0',
      padding: '11px 8px',
      color: grey600,
      fontSize: '14px',
      height: '100%',
    }),
  }
}

BuySelectInput2.defaultProps = {
  async: false,
  disabled: false,
  clearable: true,
  placeholder: 'Seleziona...',
  dataCy: '',
  values: [],
  loadOptions: () => {},
  optionHeight: 35,
}

BuySelectInput2.propTypes = {
  label: PropTypes.string,
  values: PropTypes.array,
  clearable: PropTypes.bool,
  update: PropTypes.func.isRequired,
  dataCy: PropTypes.string,
  liClassName: PropTypes.string,
  placeholder: PropTypes.string,
  optionHeight: PropTypes.number,
  async: PropTypes.bool,
  loadOptions: PropTypes.func,
}

export default BuySelectInput2
